import { PaymentMethodEnum } from 'api-hooks/payment-channel';
import HOCInput from 'components/common/hoc-input';
import { FormState, Input } from 'components/elements';
import AgentSelectInput from 'legacy-modules/master/agent/components/select-input';
import TransactionAt from 'legacy-modules/sales/component/transaction-at';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';

interface Props {
  isFilled: boolean;
}

export default function InformationField(props: Props) {
  const { t } = useTranslation();
  const { setValue } = useFormContext();
  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer
          $style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
          }}
        >
          <TransactionAt
            name="transactionAt"
            clearable={false}
            label={t('common:transaction_at')}
            placeholder={t('common:transaction_at')}
            required
          />
        </HalfContainer>
        {props.isFilled && (
          <HalfContainer>
            <Input
              type="text"
              name="number"
              label={t('common:number')}
              placeholder={t('common:number')}
              disabled
            />
          </HalfContainer>
        )}
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <FormState>
            {({ editable }) => (
              <HOCInput keys={['paymentMethod']}>
                {({ paymentMethod }) => (
                  <AgentSelectInput
                    name="agentId"
                    required
                    onAfterDetailChange={({ id }) => {
                      if (editable) {
                        setValue('agentId', id);
                        if (paymentMethod === PaymentMethodEnum.Balance) {
                          setValue('paymentableId', id);
                        }
                      }
                    }}
                    disabled={props.isFilled}
                    isShowBalance
                    isShowAccountInfo
                  />
                )}
              </HOCInput>
            )}
          </FormState>
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text-area"
            name="description"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
    </FullContainer>
  );
}
